// extracted by mini-css-extract-plugin
export var content = "_r8-1";
export var fullScreen = "_r8-0";